import React, { useEffect, useState } from 'react';
import Swiper from 'react-id-swiper';
import PropTypes from 'prop-types';
import {
  ContainerStyled,
  HeaderOvalStyled,
  SlideContainerStyled,
  SkipButtonStyled,
} from './styles/PlanDetailStyled';
import NavigationButton from './NavigationButton';
import { ReactComponent as Slide } from '../../../images/plan-recurrente/recurrente-slide.svg';

import Button from '../../General/Button';
import PlanList from './PlanList';
import { GoogleTagManager } from '../../../helpers';

const PlanInformation = ({ closePanel, segment, setBundleBuySuccess }) => {
  const [openPlanList, setOpenPlanList] = useState(false);

  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/plan-zero/paso-1',
      pagename: 'Plan Zero - Apertura Modal',
    });
  }, []);

  const params = {
    slidesPerView: '1',
    spaceBetween: 15,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    renderPrevButton: () => <NavigationButton name="swiper-button-prev" />,
    renderNextButton: () => <NavigationButton name="swiper-button-next" />,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  };

  const showPlanList = () => {
    setOpenPlanList(!openPlanList);
  };

  return (
    <>
      {!openPlanList && (
        <ContainerStyled>
          <HeaderOvalStyled />
          <Swiper
            slidesPerView={params.slidesPerView}
            spaceBetween={params.spaceBetween}
            navigation={params.navigation}
            renderPrevButton={params.renderPrevButton}
            renderNextButton={params.renderNextButton}
            pagination={params.pagination}
            breakpoints={params.breakpoints}
          >
            <SlideContainerStyled>
              <section>
                <Slide />
                <p>
                  <strong>
                    Sólo debes tener un saldo igual o mayor al valor de tu plan
                    cada 30 días
                  </strong>{' '}
                  y tu Plan Zero se renovará automáticamente.
                </p>
              </section>
              <SkipButtonStyled onClick={() => showPlanList()}>
                Omitir
              </SkipButtonStyled>
            </SlideContainerStyled>
            <SlideContainerStyled>
              <section>
                <Slide />
                <p>
                  Si no tienes saldo al final del periodo de vigencia,{' '}
                  <strong>
                    tendrás 30 días extras para poder recargar o acumular saldo
                    por el monto de tu plan
                  </strong>{' '}
                  y este se reactivará automáticamente
                </p>
              </section>
              <SkipButtonStyled onClick={() => showPlanList()}>
                Omitir
              </SkipButtonStyled>
            </SlideContainerStyled>
            <SlideContainerStyled>
              <section>
                <Slide />
                <p>
                  ¡Puedes detener el pago automático o cambiar tu plan{' '}
                  <strong>cuando quieras!</strong>
                </p>
              </section>
              <Button
                color="bubbleGum"
                maxWidth="190px"
                height="45px"
                click={() => showPlanList()}
              >
                Entendido
              </Button>
            </SlideContainerStyled>
          </Swiper>
        </ContainerStyled>
      )}

      {openPlanList && (
        <PlanList
          segment={segment}
          closePanel={closePanel}
          setBundleBuySuccess={setBundleBuySuccess}
        />
      )}
    </>
  );
};

PlanInformation.propTypes = {
  closePanel: PropTypes.func.isRequired,
  segment: PropTypes.string.isRequired,
  setBundleBuySuccess: PropTypes.func.isRequired,
};
export default PlanInformation;
